export const UserRegistrationRoutes = {
    validate: '/api/manageUser/id',
    verify: '/api/manageUser/verify',
    forgotpassverify: '/api/manageUser/forgotpassverify',
    otpVerify: (guid: string, tokenCode: string) =>
      `/api/manageUser/verify-otp/${guid}/${tokenCode}`,
    getPayDetails: '/api/manageUser/payment-details',
    paymentInitiate: '/api/manageUser/pay',
    saveOrder: '/api/manageUser/save-order',
    changePassword: '/api/manageUser/change-password',
    redirectingPaymentGateWay: '/api/manageUser/pay-redirect',
    getUser: (guid: string) => `/api/manageUser/details/${guid}`,
    resentOtp: (identifier: string, MFARequestType?: number) => `/api/manageUser/resend-otp/${identifier}/${MFARequestType}`,
    paySuccessInfo: (identifier: string) =>
      `/api/manageUser/pay-success/${identifier}`,
    payFailureInfo: (identifier: string) =>
      `/api/manageUser/pay-failure/${identifier}`,
    savecustomamount:'/api/manageUser/save-customamt'
  };
  